import React from 'react';

import { Section } from 'spectacle-ppa';
import videoSlide from '../../baseSlides/videoSlide';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile from './mme.md';

const md = new MarkdownScript(markdownFile);

function mmeSection ({ level, regionData }) {
  return (
    <Section id="mme">

      {/* MME segment */}
      {videoSlide({
        id: 'video',
        notes: md.getSubSectionAsHtml(`MME Level ${level}`, 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata(`MME Level ${level}`, 'YouTube', regionData)
      })}

    </Section>
  );
}

export default mmeSection;



// WEBPACK FOOTER //
// ./programs/zeroHeroes/sections/13_mme/mmeSection.jsx